import Box from "@mui/joy/Box";
import Stack from "@mui/joy/Stack";
import Slider from "@mui/joy/Slider";
import Typography from "@mui/joy/Typography";
import BottomSheet from "./BottomSheet";


function SettingRow({ label, value, min, max, step = 1, onChange }) {
  return (
    <Box sx={{ mb: 3 }}>
      <Stack direction="row" justifyContent="space-between" alignItems="center" mb={1}>
        <Typography level="body-sm" sx={{ fontWeight: 500, color: "text.primary" }}>
          {label}
        </Typography>
        <Box
          sx={{
            minWidth: 40, textAlign: "center",
            px: 1, py: 0.25, borderRadius: "6px",
            bgcolor: "color-mix(in srgb, var(--joy-palette-primary-500) 10%, transparent)",
          }}
        >
          <Typography level="body-xs" sx={{ fontWeight: 700, color: "primary.600", fontFamily: "monospace" }}>
            {value}px
          </Typography>
        </Box>
      </Stack>
      <Slider
        value={value}
        onChange={(_, v) => onChange(v)}
        min={min} max={max} step={step}
        color="primary" size="sm"
        sx={{
          "--Slider-trackSize": "4px",
          "--Slider-thumbSize": "18px",
          "--Slider-thumbBackground": "var(--joy-palette-primary-500)",
          py: 1,
        }}
      />
      <Stack direction="row" justifyContent="space-between" mt={0.5}>
        <Typography level="body-xs" sx={{ color: "text.tertiary", fontSize: "10px" }}>{min}px</Typography>
        <Typography level="body-xs" sx={{ color: "text.tertiary", fontSize: "10px" }}>{max}px</Typography>
      </Stack>
    </Box>
  );
}


export default function BottomSheetSettings({
  open, onClose,
  activePage,
  pagePadding, setPagePadding,
  cellGap, setCellGap,
  cellRadius, setCellRadius,
  syncSettings,
}) {
  const isCover = activePage === 0;

  const handlePadding = (v) => { setPagePadding(v); syncSettings(v, cellGap, cellRadius); };
  const handleGap     = (v) => { setCellGap(v);     syncSettings(pagePadding, v, cellRadius); };
  const handleRadius  = (v) => { setCellRadius(v);  syncSettings(pagePadding, cellGap, v); };

  return (
    <BottomSheet open={open} onClose={onClose} title="Настройки страницы">
      <Box sx={{ p: 2.5, pt: 3 }}>
        <Typography level="body-sm" sx={{ color: "text.tertiary" }}>
         Нет настроек отступов.
        </Typography>
        {/* {isCover ? (
          <Box sx={{ py: 6, textAlign: "center" }}>
            <Typography level="body-sm" sx={{ color: "text.tertiary" }}>
              У обложки нет настроек отступов.
            </Typography>
          </Box>
        ) : (
          <>
            <SettingRow
              label="Края страницы"
              value={pagePadding}
              min={0} max={40}
              onChange={handlePadding}
            />
            <SettingRow
              label="Между ячейками"
              value={cellGap}
              min={0} max={24}
              onChange={handleGap}
            />
            <SettingRow
              label="Закругление блоков"
              value={cellRadius}
              min={0} max={32}
              onChange={handleRadius}
            />
          </>
        )} */}
      </Box>
    </BottomSheet>
  );
}